module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_1920.409821b2.jpg";